import Tooltip from '@components/Tooltip/Tooltip';
import { classNames } from '@modules/classname-helpers';
import { Box, IconPadlockLocked, IconPadlockUnlocked } from '@ui-lib';

import * as styles from '../LockableTextField/LockableTextField.css';

export const LockButton = ({
  locked,
  toggleLocked,
}: {
  locked: boolean;
  toggleLocked?: () => void;
}): JSX.Element => {
  const tooltip = locked ? 'Locked' : 'Unlocked';

  // If the toggle function is undefined and the field is not locked, don't render the lock button at all
  // That is just an input which is unlocked and can't be locked, showing the lock button disabled is confusing.
  if (toggleLocked === undefined && locked === false) {
    return <></>;
  }

  return (
    <Tooltip showTriangle={true} type="dark-info" label={tooltip} aria-label={tooltip} size="small">
      <Box
        display="flex"
        disabled={toggleLocked ? false : true}
        flexDirection="row"
        alignItems="center"
        justifyContent="center"
        component="button"
        type="button"
        className={classNames(styles.LockButton, toggleLocked ? styles.InteractionStyles : '')}
        onClick={toggleLocked}
      >
        {locked ? <IconPadlockLocked /> : <IconPadlockUnlocked />}
      </Box>
    </Tooltip>
  );
};
